<template>
    <div class="">
        <div :class="[loading || form.loading ?  'active' : '']" class="dimmer">
            <div class="loader"></div>
            <div class="dimmer-content">
                <div class="row justify-content-center">
                    <div class="bg-white shadow-sm p-4">
                        <div class="card-content px-0">
                            <div class="modal-header">
                                <h5 class="modal-title font-weight-400">Business Details</h5>
                            </div>
                            <div class="p-4">
                                <form @submit.prevent="create" method="post">
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Corporate Name</label>
                                                <input type="text" v-model="form.name"
                                                       :class="[ 'form-control' , form.errors.get('name') ? 'is-invalid' : '' ]">
                                                <div v-text="form.errors.get('name')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Industry</label>
                                                <select v-model="form.industry"
                                                        :class="[ 'form-control' , form.errors.get('industry') ? 'is-invalid' : '' ]">
                                                         <option v-for="i in industries" :key="i" :value="i">{{ i }}</option>
                                                </select>
                                                <div v-text="form.errors.get('industry')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Address Lines</label>
                                                <textarea type="text" v-model="form.address"
                                                          rows="1"
                                                          :class="[ 'form-control' , form.errors.get('address') ? 'is-invalid' : '' ]"
                                                          placeholder="Enter your corporate address"></textarea>
                                                <div v-text="form.errors.get('address')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Address City</label>
                                                <select v-model="form.city"
                                                        :class="[ 'form-control' , form.errors.get('city') ? 'is-invalid' : '' ]">
                                                    <option v-for="i in cities" :key="i" :value="i">{{ i }}</option>
                                                </select>
                                                <div v-text="form.errors.get('city')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Contact Name</label>
                                                <input type="text" v-model="form.contact_name"
                                                       :class="[ 'form-control' , form.errors.get('contact_name') ? 'is-invalid' : '' ]">
                                                <div v-text="form.errors.get('contact_name')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Contact Last Name</label>
                                                <input type="text" v-model="form.contact_last_name"
                                                       :class="[ 'form-control' , form.errors.get('contact_last_name') ? 'is-invalid' : '' ]">
                                                <div v-text="form.errors.get('contact_last_name')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Contact Phone</label>
                                                <input type="text" v-model="form.contact_phone"
                                                       :class="[ 'form-control' , form.errors.get('contact_phone') ? 'is-invalid' : '' ]">
                                                <div v-text="form.errors.get('contact_phone')"
                                                     class="invalid-feedback"/>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label>Contact Email</label>
                                                <input type="text" v-model="form.contact_email"
                                                       :class="[ 'form-control' , form.errors.get('contact_email') ? 'is-invalid' : '' ]">
                                                <div v-text="form.errors.get('contact_email')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>Logo</label>
                                                <input type="file" id="file" @change="fileChange"  ref="file"  accept="image/*" :class="[ 'form-control' , form.errors.get('corporate_logo') ? 'is-invalid' : '' ]">
                                                <div v-text="form.errors.get('corporate_logo')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                    </div>

                                    <button @click.prevent="create"
                                            :class="['btn btn-primary btn-block mt-2' ,  form.loading ? 'btn-loading' : '']"
                                            type="submit">Save Changes
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../core/forms/form";

export default {
    name: "Index",
    metaInfo: {
      title: 'Business Settings'
    },
    data() {
        return {
            industries: [],
            cities: [],
            loading: false,
            form: new Form({
                name: '',
                industry: '',
                address: '',
                city: '',
                contact_name: '',
                contact_email: '',
                contact_phone: '',
                contact_last_name: '',
                corporate_logo : '',
            }, {}),
        };
    },

    mounted() {
        this.init();
    },

    methods: {

        fileChange : function ()
        {
            this.form.corporate_logo = this.$refs.file.files[0];
        },

        init() {
            this.loading = true;
            window.axios.get(`/business/settings/api`).then((response) => {
                this.form.name = response.data.body.model.name;
                this.form.industry = response.data.body.model.industry;
                this.form.address = response.data.body.model.address;
                this.form.contact_name = response.data.body.model.contact_name;
                this.form.contact_email = response.data.body.model.contact_email;
                this.form.contact_phone = response.data.body.model.contact_phone;
                this.form.contact_last_name = response.data.body.model.contact_last_name;
                this.form.city = response.data.body.model.city;
                this.loading = false;
            });
            window.axios.get('/file/corporate_industries.json').then(response =>  this.industries = response.data)
            window.axios.get('/file/corporate_zim_cities.json').then(response =>  this.cities = response.data)
        },
        create() {
            this.form.upload(`/business/settings/update`).then((response) => {
                this.init();
            }).catch((error) => {
            }).finally(() => {
            });
        }
    }
}
</script>
